import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import { LandingPage } from "./components/LandingPage.tsx";
import { AboutPage } from "./components/AboutPage.tsx";
import { TransferPage } from "./components/TransferPage.tsx";
import { RecoveryPage } from "./components/RecoveryPage.tsx";
import { Navbar } from "./components/Navbar.tsx";
function AppLayout() {
  return (
    <div className="min-h-screen flex flex-col" style={{ background: "#0e1a2a" }}>
      <Navbar />
      <Outlet />
    </div>
  );
}

export function App() {
  return (
    <Routes>
      <Route path="/" element={<div className="min-h-screen" style={{ background: "#0e1a2a" }}><LandingPage /></div>} />
      <Route path="/about" element={<AboutPage />} />
      <Route element={<AppLayout />}>
        <Route path="/app" element={<TransferPage />} />
        <Route path="/app/recovery" element={<RecoveryPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
